import { apiFetch } from "./apiFetch";

// Admin "Usage" dashboard — reads the backend's API request logs
// (routes/admin/usage.js). Every list/aggregate accepts the same filters:
// from, to (ISO), role, origin, endpoint, method, status (ok|error), userId, search.

function toQuery(filters = {}) {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "" && v !== "all") params.set(k, String(v));
  });
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}

export const fetchUsageSummary = (filters) => apiFetch(`/admin/usage/summary${toQuery(filters)}`);
export const fetchUsageTimeseries = (filters) => apiFetch(`/admin/usage/timeseries${toQuery(filters)}`);
export const fetchUsageEndpoints = (filters) => apiFetch(`/admin/usage/endpoints${toQuery(filters)}`);
export const fetchUsageUsers = (filters) => apiFetch(`/admin/usage/users${toQuery(filters)}`);
export const fetchUsageRequests = (filters) => apiFetch(`/admin/usage/requests${toQuery(filters)}`);
export const fetchUsageRequest = (id) => apiFetch(`/admin/usage/requests/${id}`);
export const fetchUsageSlow = (filters) => apiFetch(`/admin/usage/slow${toQuery(filters)}`);
export const fetchUsageAuthFunnel = (filters) => apiFetch(`/admin/usage/auth-funnel${toQuery(filters)}`);
